import { Pipe, PipeTransform } from '@angular/core';
import { cloneDeep } from 'lodash';

@Pipe({
  name: 'filter'
})
export class ArrayFilterPipe implements PipeTransform {

  transform<T>(value: T[], filterBy: any, excludeBy?: any): T[] {
    if (!value) return [];

    return value.filter(row => {

      if (filterBy) {
        for (const key of Object.keys(filterBy)) {
          if (filterBy[key] !== row[key]) {
            return false;
          }
        }
      }

      if (excludeBy) {
        for (const key of Object.keys(excludeBy)) {
          if (excludeBy[key] === row[key]) {
            return false;
          }
        }
      }

      return true;

    });
  }

}
